import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import viacapLogo from '../images/viacap_logo.png';
import hmarLogo from '../images/hmar_logo.png';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    paddingTop: '30px',
    paddingBottom: '20px',
  },
  logosRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    gap: '60px',
    marginBottom: '16px',
  },
  logoItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
  },
  logoLabel: {
    fontSize: '0.75rem',
    color: 'rgba(255, 255, 255, 0.85)',
  },
  footerLogo: {
    height: '60px',
  },
  viacapLogo: {
    height: '60px',
  },
  socialMedia: {
    marginBottom: '16px',
  },
  socialMediaIcon: {
    margin: '0 12px',
    opacity: 0.9,
    '&:hover': {
      opacity: 1,
    },
  },
  legalText: {
    fontSize: '0.75rem',
    margin: '0 auto',
    maxWidth: '700px',
    padding: '0 20px 20px',
    color: 'rgba(255, 255, 255, 0.85)',
    lineHeight: 1.6,
    '& a:link': {
      color: '#FFFFFF',
    },
    '& a:visited': {
      color: '#FFFFFF',
    },
    '& a:hover': {
      color: '#D5EBD5',
    },
  },
}));

export default function OnaBetFooter() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.logosRow}>
        <div className={classes.logoItem}>
          <span className={classes.logoLabel}>Títulos emitidos por:</span>
          <img src={viacapLogo} className={classes.viacapLogo} />
        </div>
        <div className={classes.logoItem}>
          <span className={classes.logoLabel}>Instituição Beneficiada:</span>
          <img src={hmarLogo} className={classes.footerLogo} />
        </div>
      </div>
      <div className={classes.legalText}>
        Título de Capitalização da Modalidade Filantropia Premiável de Contribuição Única,
        emitido pela VIACAP Capitalização S/A, CNPJ 88.076.302/0001-94, aprovado pelo
        Processo SUSEP que consta no Título. SAC 0800 740 7819. OUVIDORIA 0800 8741 505,
        de segunda a sexta-feira, das 8h às 17h.
        É proibida a venda de título de capitalização a menores de dezesseis anos.
        O valor não exigido dentro do prazo prescricional, estabelecido pela legislação
        em vigor, acarretará a perda desse direito. A aquisição deste título implica a
        cessão de 100% do direito de resgate à LIGA NORDESTINA DE ASSISTÊNCIA A SAÚDE DE
        PERNAMBUCO - HOSPITAL MEMORIAL ALZIRA RIBEIRO, pessoa jurídica de direito privado,
        beneficente de assistência social, inscrita no CNPJ sob n.º 35.673.300/0001-16,
        com sede na Rua João de Deus, nº 310, Centro, Agrestina/PE, CEP 55495-000,
        certificada nos termos da legislação em vigor. Antes de contratar consulte previamente as Condições Gerais.
        As condições contratuais/regulamento deste produto protocolizadas pela sociedade
        junto à SUSEP poderão ser consultadas no endereço eletrônico www.susep.gov.br,
        de acordo com o número de processo constante da proposta. Consulte as informações
        legais da Resolução CNSP 382/2020 em www.viacapitalizacao.com.br. Premiação paga
        em valor líquido, já descontado o Imposto de Renda. Confira o resultado dos sorteios
        e as condições de participação em www.edscap.com.br.
        <br />
        Imagens meramente ilustrativas.
        <br /><br />
        <a href="/site/termos" target="_blank" rel="noopener noreferrer">Termos de Uso</a> | <a href="/site/politicas" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
        <br /><br />
        Edscap LTDA - 52.559.942/0001-08
      </div>
    </div>
  );
}
